<template>
    <div class="embryo-fert-card">
        <day-image :image-url="pnImageUrl" />

        <div class="embryo-details">
            <p>{{ $translate('e_id') }}: {{ well.index + 1 }}</p>

            <fertilization-type-select :default-type="defaultFertType" class="field" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DayImage from '../DayImage'
import FertilizationTypeSelect from '../FertilizationTypeSelect'

export default {
    name: 'EmbryoFertCard',
    components: { DayImage, FertilizationTypeSelect },
    props: {
        well: {
            type: Object,
            required: true
        },
        defaultFertType: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            getPnImageUrl: 'timelapse/getPnImageUrl'
        }),
        pnImageUrl() {
            return this.getPnImageUrl(this.well)
        }
    }
}
</script>

<style lang="scss" scoped>
.embryo-fert-card {
    height: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 5px;
    padding: 10px;

    .embryo-details {
        padding: 5px 0;
    }

    @media screen {
        border: solid 1px $light;
        border-radius: 4px;
    }
    @media print {
        border: solid 1px $report-color;

        .embryo-details .fertilization-type-select {
            padding: 5px 0;
            justify-content: start;
        }
    }
}
</style>
